import { UserRole } from 'core/constants';

export const ALL_ROLES = Object.values(UserRole);

export const NON_ARC_OPERATORS = [UserRole.Admin, UserRole.Manager, UserRole.AccountManager, UserRole.User];

export const ADMIN_AND_ACCOUNT_MANAGERS = [UserRole.Admin, UserRole.AccountManager];

export const NON_USER = [UserRole.Admin, UserRole.Manager, UserRole.AccountManager, UserRole.ArcOperator];

export const ADMIN_AND_MANAGERS = [UserRole.Admin, UserRole.Manager, UserRole.AccountManager];

export const MANAGERS = [UserRole.Manager, UserRole.AccountManager];
